import Vue, { mergeData } from '../../vue'
import { NAME_INPUT_GROUP_TEXT } from '../../constants/components'
import { makePropsConfigurable } from '../../utils/config'

export const props = makePropsConfigurable(
  {
    tag: {
      type: String,
      default: 'div'
    }
  },
  NAME_INPUT_GROUP_TEXT
)

// @vue/component
export const BInputGroupText = /*#__PURE__*/ Vue.extend({
  name: NAME_INPUT_GROUP_TEXT,
  functional: true,
  props,
  render(h, { props, data, children }) {
    return h(
      props.tag,
      mergeData(data, {
        staticClass: 'input-group-text'
      }),
      children
    )
  }
})
